<template>
    <div v-if="entradas_por_provincia" class="table-responsive m-0">
        <span style="font-size: 17.6px; font-weight: 400; color: rgb(68, 68, 68); font-family: Oswald, sans-serif; margin: 5px; padding: 3px;">Total de entradas por Provincia</span>
        <b-table :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" style="margin-top: 10px;" hover :items="entradas_por_provincia" :fields="fields" id="total-provincias-table" :per-page="perPage" :current-page="currentPage">
            <template #cell(provincia)="data">
                {{ data.item.nombre }}
            </template>
            <template #cell(total)="data">
                {{ data.item.total }}
            </template>
        </b-table>
        <b-pagination :per-page="perPage" aria-controls="cp-table" v-model="currentPage" :total-rows="entradas_por_provincia.length" size="sm"/>
    </div>
</template>

<script>
    export default {
        props: ['event_id'],
        data() {
            return {
                sortBy: 'total',
                sortDesc: true,
                fields: [
                    { key: 'provincia', label: 'Provincia' },
                    { key: 'total', label: 'Total', 'sortable': true }
                ],
                cpToInfo: {},
                perPage: 10,
                currentPage: 1,
                entradas_por_provincia: null
            }
        },
        created() {
            this.getTotalEntradasPorProvincia();
        },
        methods: {
            getTotalEntradasPorProvincia() {
                const params = {
                    filters : {},
                    evento_id: this.event_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.total-entradas-por-provincia'), params).then(res => {
                    this.entradas_por_provincia = res.data;

                    this.$emit('totalEntradasProvincia', this.entradas_por_provincia);
                });
            },
        }
    }
</script>